import React, { useContext, useState } from 'react';

import { MoreMenu as MoreMenuButton } from '@motorway/motorway-storybook-cra';

import cypressIds from 'Components/cypress_ids.json';
import { VehicleContext } from 'Context/VehicleContext';
import { triggerCompleteMoreMenuClickedEvent } from 'Services/analytics/events';
import { applyCypressData } from 'Utilities/helpers';
import { useUpdateDeliveryStatus } from 'Utilities/hooks/account/useUpdateDeliveryStatus/useUpdateDeliveryStatus';

import MoreMenuModal from '../MoreMenuModal/MoreMenuModal';

const MoreMenu = ({ triggerSuccessToast }) => {
	const { id: enquiryId } = useContext(VehicleContext);
	const [shouldShowModal, setShouldShowModal] = useState(false);

	const { mutate: mutateDeliveryStatus } = useUpdateDeliveryStatus();

	const onMoreMenuClick = () => {
		setShouldShowModal(true);
		triggerCompleteMoreMenuClickedEvent({ id: enquiryId });
	};

	const onDismissModal = () => {
		setShouldShowModal(false);
	};

	const onMutateDeliveryStatus = (deliveredStatus, enquiryId) => {
		mutateDeliveryStatus(
			{
				deliveredStatus,
				enquiryId,
			},
			{
				onSuccess: (_, variables) => {
					triggerSuccessToast(_, variables);
				},
			},
		);
	};

	const moreMenuButton = (
		<MoreMenuButton
			extraProps={{
				'aria-label': 'more-menu',
				onClick: onMoreMenuClick,
				...applyCypressData(cypressIds.buttons.moreMenu),
			}}
		/>
	);

	return (
		<>
			{moreMenuButton}
			{shouldShowModal ? (
				<MoreMenuModal onDismissModal={onDismissModal} onMutateDeliveryStatus={onMutateDeliveryStatus} />
			) : null}
		</>
	);
};

export default MoreMenu;
